import { List, Sheet, listItemButtonClasses, listItemClasses, Typography } from '@mui/joy';
import { ReactNode, useEffect } from 'react'
import { getUserLinks } from '../../controllers/userDataController';
import { useUserDataContext, useUserDataDispatchContext } from '../../LinkDataStore/Context';
import { useStateContext } from '../../Store/Context';
import { IDataCategoryLinks } from '../../types';
import SingleCategory from './SingleCategory';

const CategoryAndLinks = () => {

	const userDataDispatch = useUserDataDispatchContext();
	const userDataState = useUserDataContext();
	const { medium } = useStateContext();

	useEffect(() => {
		async function getData() {
			await getUserLinks(userDataDispatch);
		}

		getData();

	}, [userDataDispatch]);

	return (
		<Sheet
			sx={{
				width: "100%",
				padding: "0 20px",
				overflowY: "auto",
				maxHeight: medium === 'web' ? "100%" : "350px",
				'&::-webkit-scrollbar': {
					width: '0.4em'
				},
				'&::-webkit-scrollbar-track': {
					boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
					webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
				},
				'&::-webkit-scrollbar-thumb': {
					backgroundColor: 'var(--joy-palette-primary-500)',
					outline: '1px solid var(--joy-palette-primary-500)'
				}
			}}
		>
			<Typography variant='plain' textColor='neutral' level='h5'>Your links</Typography>
			<List
				sx={() => ({
					'--List-insetStart': '32px',
					'--List-item-paddingY': '0px',
					'--List-item-paddingRight': '16px',
					'--List-item-paddingLeft': '30px',
					'--List-item-startActionWidth': '0px',
					'--List-item-startActionTranslateX': '-50%',

					[`& .${listItemButtonClasses.root}`]: {
						borderLeft: '1px solid',
						borderColor: 'divider',
					},
					[`& .${listItemButtonClasses.root}.${listItemButtonClasses.selected}`]:
					{
						borderColor: 'currentColor',
					},
					[`& .${listItemClasses.nested} > .${listItemButtonClasses.root}`]: {
						border: 'none',
					},
					'& [class*="startAction"]': {
						color: 'var(--joy-palette-text-tertiary)',
					},
				})}
			>
				{
					userDataState.data.map((element: IDataCategoryLinks): ReactNode => {
						return (
							<SingleCategory shared={false} key={element._id} data={element} />
						)
					})
				}
			</List>
		</Sheet>
	)
}

export default CategoryAndLinks;